import React from 'react';
import { Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { formatDateAsSent } from '../../../utils/dateUtils';
import { showAmount, showMovement, movementColor } from './ledgerAmount';

/** Ledger rows as a scrollable table, used at `sm` and above. */
const LedgerTable = ({ ledgerData, onRowClick }) => {
  const theme = useTheme();
  return (
            <TableContainer sx={{ 
              flex: 1,
              overflow: 'auto',
              overflowX: 'auto',
              minHeight: 0,
              willChange: 'scroll-position',
              WebkitOverflowScrolling: 'touch',
              overscrollBehavior: 'contain',
              '&::-webkit-scrollbar': {
                height: '8px',
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: theme.palette.grey[100],
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: theme.palette.grey[400],
                borderRadius: '4px',
                '&:hover': {
                  backgroundColor: theme.palette.grey[500],
                },
              },
            }}>
            <Table 
              stickyHeader 
              aria-label="sticky table" 
              size="medium"
              sx={{
                tableLayout: 'auto',
                // Same alignment as Trade History: the first column (the
                // date) left-aligned, every other value centred under its
                // column name.
                '& th, & td': { textAlign: 'center' },
                '& th:first-of-type, & td:first-of-type': { textAlign: 'left' },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>Transaction Date</TableCell>
                  <TableCell>Narration</TableCell>
                  <TableCell>Debit</TableCell>
                  <TableCell>Credit</TableCell>
                  <TableCell>Balance</TableCell>
                  <TableCell width="40px"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ledgerData.map((entry) => (
                  <TableRow 
                    hover 
                    tabIndex={-1} 
                    key={entry.id}
                    onClick={() => onRowClick(entry)}
                    sx={{ 
                      cursor: 'pointer',
                      '&:hover .info-icon': {
                        opacity: 1
                      }
                    }}
                  >
                    <TableCell>{formatDateAsSent(entry.created_at)}</TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {entry.narration}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ color: movementColor(-(parseFloat(entry.debit) || 0)) }}>
                      {showMovement(entry.debit)}
                    </TableCell>
                    <TableCell sx={{ color: movementColor(parseFloat(entry.credit) || 0) }}>
                      {showMovement(entry.credit)}
                    </TableCell>
                    <TableCell>{showAmount(entry.balance)}</TableCell>
                    <TableCell>
                      <InfoIcon 
                        className="info-icon"
                        sx={{ 
                          fontSize: '1.2rem',
                          color: theme.palette.primary.main,
                          opacity: 0.3,
                          transition: 'all 0.2s ease',
                          cursor: 'pointer',
                          '&:hover': {
                            opacity: 1,
                            transform: 'scale(1.1)'
                          }
                        }} 
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            </TableContainer>
  );
};

export default LedgerTable;
